import React, { Ref } from "react";
import { EntityDescriptor } from "../entity_crud/EntityDescriptor";
import { EntityEditorFormSimple } from "../entity_crud/EntityEditorFormSimple";
import { IReportDescriptor } from "./IReportDescriptor";
import { CrudViewer } from "../entity_crud/CrudViewer";

export class ReportDescriptorMaterializer {
    
    reportDescriptor: IReportDescriptor;

    constructor(reportDescriptor: IReportDescriptor) {
        this.reportDescriptor = reportDescriptor;
    }

    /**
     * Creates a complete EntityDescriptor with all FieldDescriptors.
     * Table and editor components need full FieldDescriptor objects to work properly.
     */
    private getFullEntityDescriptor(): EntityDescriptor {
        const ed = new EntityDescriptor({ name: "Report." + this.reportDescriptor.id });
        Object.values(this.reportDescriptor.paramDtoDescriptor.fields).map(field => {
            ed.addFieldDescriptor(field);
        });
        return ed;
    }

    getLabel() {
       return _msg("Report." + this.reportDescriptor.id + ".title");
    }

    getDescription() {
        return _msg("Report." + this.reportDescriptor.id + ".description");
    }

    renderParamEditorForm(paramFormRef: React.RefObject<EntityEditorFormSimple>, paramJson?: any) {
        return <EntityEditorFormSimple ref={paramFormRef} hideButtonBar entity={paramJson} entityDescriptor={this.getFullEntityDescriptor()} />
    }

    renderParamEditorProperties(paramJson?: any) {
        return <CrudViewer entity={paramJson} entityDescriptor={this.getFullEntityDescriptor()} fields={Object.keys(this.reportDescriptor.paramDtoDescriptor.fields)}/>
    }

}